import { FormEvent, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { identityApi, type IdentityRecord } from '../../api/identity';

export function IdentityPreferencesPage() {
  const { id = '' } = useParams();
  const [identity, setIdentity] = useState<IdentityRecord | null>(null);
  const [locale, setLocale] = useState('en-US');
  const [timezone, setTimezone] = useState('UTC');
  const [language, setLanguage] = useState('en');
  const [theme, setTheme] = useState('system');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    void identityApi.get(id).then((data) => {
      setIdentity(data);
      const prefs = (data as IdentityRecord & { preferences?: { locale?: string; timezone?: string; language?: string; theme?: string } }).preferences;
      if (prefs?.locale) setLocale(prefs.locale);
      if (prefs?.timezone) setTimezone(prefs.timezone);
      if (prefs?.language) setLanguage(prefs.language);
      if (prefs?.theme) setTheme(prefs.theme);
    }).catch((err) => setError(err instanceof Error ? err.message : 'Load failed'));
  }, [id]);

  async function onSave(e: FormEvent) {
    e.preventDefault();
    try {
      const updated = await identityApi.patch(id, { locale, timezone, language, theme });
      setIdentity(updated);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Save failed');
    }
  }

  return (
    <div className="mx-auto max-w-3xl p-6">
      <Link to={`/identity/${id}`} className="text-sm text-slate-600 hover:underline">← Details</Link>
      <h1 className="mt-4 text-2xl font-semibold text-slate-900">Identity Preferences</h1>
      {error && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
      {identity && (
        <form onSubmit={onSave} className="mt-6 grid gap-3 rounded-xl border border-slate-200 bg-white p-4 md:grid-cols-2">
          <label className="block text-sm text-slate-600">Locale
            <input value={locale} onChange={(e) => setLocale(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
          </label>
          <label className="block text-sm text-slate-600">Timezone
            <input value={timezone} onChange={(e) => setTimezone(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
          </label>
          <label className="block text-sm text-slate-600">Language
            <input value={language} onChange={(e) => setLanguage(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
          </label>
          <label className="block text-sm text-slate-600">Theme
            <select value={theme} onChange={(e) => setTheme(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2">
              <option value="system">System</option>
              <option value="light">Light</option>
              <option value="dark">Dark</option>
            </select>
          </label>
          <button type="submit" className="rounded-lg bg-slate-900 px-4 py-2 text-white md:col-span-2 md:w-fit">Save preferences</button>
        </form>
      )}
    </div>
  );
}
